<div class="flex flex-col" *transloco="let t">
  <ITabs [tabs]="tabs" [activeTab]="activeTab()" />

  <div class="my-3 flex justify-end">
    <div class="flex items-center gap-2">
      @if (selectedRows().length > 0) {
        <button
          iButton
          variant="destructive"
          [disabled]="isReadOnly()"
          testId="btn-delete-all-segments"
          (click)="deleteSegments(selectedRows())"
        >
          <IIcon name="trash" />
          {{ t("segment-manager.remove_selected_selectedrows_length", { count: selectedRows().length }) }}
        </button>
      }
      <button iButton [disabled]="isReadOnly()" (click)="createNewSegment()">
        <IIcon name="plus" />
        {{
          activeTab() === SegmentType.KeywordSegment
            ? t("segment-manager.create_new_keyword_segment")
            : t("segment-manager.create_new_product_segment")
        }}
      </button>
      <app-export-button
        (export)="downloadCsv()"
        tooltipValue="{{ t('segment-manager.export_segment_list_as_csv') }}"
      ></app-export-button>
    </div>
  </div>
  <div class="table-container">
    <ag-grid-angular
      #grid
      class="ag-theme-quartz base-theme mb-2 h-[65rem] flex-1"
      [gridOptions]="gridOptions"
      [columnDefs]="colDef"
      [rowData]="segments()"
      (gridReady)="onGridReady($event)"
    ></ag-grid-angular>
  </div>
</div>
